import { render, staticRenderFns } from "./Plant.vue?vue&type=template&id=283f2fdc&scoped=true&"
import script from "./Plant.vue?vue&type=script&lang=ts&"
export * from "./Plant.vue?vue&type=script&lang=ts&"
import style0 from "./Plant.vue?vue&type=style&index=0&id=283f2fdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283f2fdc",
  null
  
)

export default component.exports